// @flow

import { View } from 'reshaped';

import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { useCartSummaryContext } from '../../../context/CartSummary';

import { ButtonContent } from './ButtonContent';

import { CartSummaryPriceBreakdown } from './CartSummaryPriceBreakdown';

import styles from './Button.scss';

type Props = {
  price: string,
};

export function ContactFormSubmitButton({ price }: Props): React.MixedElement {
  const { __ } = useTranslator();
  const { submitting } = useCartSummaryContext();

  return (
    <View width="100%" gap={4}>
      <CartSummaryPriceBreakdown />
      <Button
        type="submit"
        form="account-form"
        className={styles.button}
        loading={submitting}
        block
      >
        <ButtonContent addon={price}>{__('Continue')}</ButtonContent>
      </Button>
    </View>
  );
}
